import { render, staticRenderFns } from "./MealPlanStep.vue?vue&type=template&id=87d98078&scoped=true&"
import script from "./MealPlanStep.vue?vue&type=script&lang=js&"
export * from "./MealPlanStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d98078",
  null
  
)

export default component.exports